import { render, staticRenderFns } from "./RequirementList.vue?vue&type=template&id=a5577a58&scoped=true&"
import script from "./RequirementList.vue?vue&type=script&lang=js&"
export * from "./RequirementList.vue?vue&type=script&lang=js&"
import style0 from "./RequirementList.vue?vue&type=style&index=0&id=a5577a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5577a58",
  null
  
)

export default component.exports